import { render, staticRenderFns } from "./JsonSchemaForm.vue?vue&type=template&id=0b32eb09"
import script from "./JsonSchemaForm.vue?vue&type=script&lang=js"
export * from "./JsonSchemaForm.vue?vue&type=script&lang=js"
import style0 from "./JsonSchemaForm.vue?vue&type=style&index=0&id=0b32eb09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports